import React,{Component} from 'react';
// import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import * as actions from '../../../actions';
import {browserHistory,Link} from 'react-router';
import { Modal, Button,FormGroup,Radio } from 'react-bootstrap';
import WebFooter from './WebFooter.js';
import WebHeaderInner from './WebHeaderInner.js';
import $ from 'jquery';
// import $ from 'jquery';
class Web_EnquireNow_Partner extends Component{
	constructor(props){
		super(props);
			this.state={
				ltype : this.props.params.Ltype,
				sid: this.props.params.Sid,
				did: this.props.params.Did,
				showModal: false,
				stype:0,
				rtype:0,
				textarea_msg: '',
				comp_name: '',
				email_fld:'',
				stype_status: false,
				stype1: false,
				rtype1: false,
				rtype_status: false,
				user_mob_num: '',
          		user_name:'',
          		message:'',
			};
	this.modalOpen=this.modalOpen.bind(this);
    this.close=this.close.bind(this);
    this.closeModal=this.closeModal.bind(this);
    this.getCat=this.getCat.bind(this);
    this.txtAreaChange=this.txtAreaChange.bind(this);
    this.getCompName=this.getCompName.bind(this);
    this.getEmail=this.getEmail.bind(this);
    this.validateData=this.validateData.bind(this);
    this.getDeviceId=this.getDeviceId.bind(this);
    this.getRole=this.getRole.bind(this);
    this.getUserDetails=this.getUserDetails.bind(this);
    this.saveLead=this.saveLead.bind(this);
	};
	getEmail(event)
	{
		event.preventDefault();
		this.setState({
			email_fld: this.refs.email_ref_fld.value,
		});
	}
	getCat(x)
	{
		this.setState({
			stype:x,
			stype_status: true,
			// stype1:false,
		},()=>{console.log(this.state.stype)} );
	}
	validateData(event)
	{
		event.preventDefault();
		// this.setState({
		// 	stype1 : true,
		// 	rtype1: true,
		// });
		if(this.state.stype1===false)
		{
			this.setState({
				stype1:true,
			});
		}
		if(this.state.rtype1===false)
		{
			this.setState({
				rtype1:true,
			});
		}
	}
	txtAreaChange(event)
	{
		event.preventDefault();
		this.setState({
			textarea_msg: this.refs.txtAreaMsg.value,
		});
	}
	modalOpen()
  	{
	  this.setState({
	    showModal: true
	  });
  	}
	closeModal()
	{
	  this.setState({
	    showModal: false,
	  });
	}
	close()
	{
	  this.setState({
	    showModal: false,
	  });
	}

	componentWillReceiveProps(newProps)
	{
	    // if (newProps.leads === 1 || newProps.leads.status === 'success') 
	    // {
	    //   this.setState({showModal: true});
	    // }
	    
	      // this.setState({showModal: false});
	    
	}
	getRole(x)
	{
		// alert(x);
		this.setState({
			rtype:x,
			rtype_status: true,
			// rtype1: false,
		},()=>{console.log(this.state.rtype)} );
		// console.log(this.state.cat);
	}

	handleFormSubmit(formProps)
	{
		// console.log(this.state.ltype);
		if(this.state.stype === 0){
			this.setState({
					stype_status: true,
			});
		}
		else
		{
			this.setState({
				stype_status: false,
			});
		}
		if(this.state.rtype === 0)
		{
			this.setState({
				rtype_status: true,
			});
		}
		else
		{
			this.setState({
				rtype_status: false,
			});
		}
		if(this.state.ltype === "seed")
		{
			this.props.saveseed_lead(formProps,this.state.sid,this.state.did);
		}
		if(this.state.ltype === "feed")
		{
			this.props.savefeed_lead(formProps,this.state.sid,this.state.did);	
		}
		if(this.state.ltype === "seller")
		{
			this.props.track_seller_lead(formProps,this.state.user_mob_num,this.state.user_name,this.state.sid,this.state.did,this.state.stype,this.state.rtype,this.state.textarea_msg);	
			//this.props.track_seller_lead(formProps,this.state.sid,this.state.did);	
		}
		if(this.state.ltype === "nodata")
		{
			this.props.track_user_lead(formProps,this.state.sid,this.state.did);	
		}
		else
		{
			// var frm='desktop_web';
			// this.props.track_seller_lead(formProps,frm,this.state.user_mob_num,this.state.user_name,this.state.sid,this.state.did,this.state.stype,this.state.rtype,this.state.textarea_msg);
			this.saveLead(this.state.user_mob_num,this.state.user_name,this.state.sid,this.state.did,this.state.stype,this.state.rtype,this.state.textarea_msg,this.state.email_fld,this.state.comp_name);
		}
	}
		

	saveLead(user_mobile,user_name,seller_id,deal_id,stype,role,message,email,company_name)
	{
	var id = '';
      if(localStorage.user_id)
      {
         id = localStorage.user_id;  
      }
      else {
         id = localStorage.ip;
      }
      var token='';
      if(localStorage.token)
      {
        token=localStorage.token;
      }
      else
      {
        token=0;
      }

        if(localStorage.source)
		{
			var source=localStorage.getItem('source');
		}
		else
		{
			source='';
		}
		if(localStorage.campaign)
		{
			var campaign=localStorage.getItem('campaign');
		}
		else
		{
			campaign='';
		}
		if(localStorage.url_id)
		{
			var url_id=localStorage.getItem('url_id');
		}
		else
		{
			url_id='';
		}
       var data1={from:'desktop_web','id' : id,'token': token,'name' : user_name,'mobile': user_mobile,'email': email,'cname':company_name,'stype':stype,'role':role,'message':message,'seller_id': seller_id,'deal_id' : deal_id,source:source,campaign:campaign,url_id:url_id};
	   var data2=JSON.stringify(data1);
	    var baseUrl='https://aquadeals.in/admin/web3/user/';
	    $.ajax({
	        method: 'POST',
	        url: baseUrl+'trackSellerLead',
	        dataType: 'json',
	        data:{req: data2},
	        success: function(data)
	        {
	          if(data.status==="success")
	          {
	          	this.setState({
	          		showModal:true,
	          		message:data.message
	          	});
	          }
	        }.bind(this),
	        error: function(err)
	        {
	        }
	    });
     
	}

	getDeviceId()
	{
	    if(localStorage.user_id)
	    {
	        var user_id=localStorage.user_id;
	    }
	    else
	    {
	      user_id=0;
		    }
		if(localStorage.source)
		{
			var source=localStorage.getItem('source');
		}
		else
		{
			source='';
		}
		if(localStorage.campaign)
		{
			var campaign=localStorage.getItem('campaign');
		}
		else
		{
			campaign='';
		}
		if(localStorage.url_id)
		{
			var url_id=localStorage.getItem('url_id');
		}
		else
		{
			url_id='';
		}
	    var data1={from: 'desktop_web',id: user_id, device_id: localStorage.getItem('push_device_id'),source:source,campaign:campaign,url_id:url_id}
	    var data2=JSON.stringify(data1);
	    var baseUrl='https://aquadeals.in/admin/web3/user/';
	    $.ajax({
	        method: 'POST',
	        url: baseUrl+'getDeviceId',
	        dataType: 'json',
	        data:{req: data2},
	        success: function(data)
	        {
	          
	        },
	        error: function(err)
	        {
	        }
	    });
	  }
	componentDidMount()
	{
	  window.scrollTo(0, 0);            
	  if(screen.width < 800)
	  {
	    window.location.href="/enquire_now/partner/support/sid/did";
	  }
	  this.refs.comp_ref_name.focus();
	  this.getDeviceId();

	  if(!localStorage.token && !localStorage.user_id)
	  {
	    localStorage.setItem('w_r_enq_seller_page','/web/enquire_now/partner/support/sid/did');
		localStorage.removeItem('w_r_s_dt');
	    localStorage.removeItem('w_r_e_coupon_dt');
	    localStorage.removeItem('w_r_e_s_dt');
	    localStorage.removeItem('web_mycart');
	  
	    localStorage.removeItem('w_r_p_dt');
	    localStorage.removeItem('w_r_e_p_dt');
	    localStorage.removeItem('web_ofr_page');
	    localStorage.removeItem('profile');
	    localStorage.removeItem('myaquacash');
	    localStorage.removeItem('web_share_earn');
	    localStorage.removeItem('checkout');
	    localStorage.removeItem('order_details');
	    localStorage.removeItem('myorders');
	    localStorage.removeItem('w_r_p_deals');
	    localStorage.removeItem('seed');
	    localStorage.removeItem('nauplii');
	    localStorage.removeItem('subdeals');
	    localStorage.removeItem('shipping');
	    localStorage.removeItem('notifications');
	    localStorage.removeItem('web_quickcart');
	    localStorage.removeItem('view_rating');
	    localStorage.removeItem('w_modal_seed');
	    localStorage.removeItem('w_r_seed_deals');
	    localStorage.removeItem('w_r_e_p_dt');
	    localStorage.removeItem('w_modal_details');
	    localStorage.removeItem('offers');
	    localStorage.removeItem('give_rating');
	    localStorage.removeItem('pprice');
	    localStorage.removeItem('sprice');
	    localStorage.removeItem('seed_id');
	    localStorage.removeItem('h_type');
	    localStorage.removeItem('web_pro_ofr_dtls');
	    localStorage.removeItem('web_wishlist');
	    localStorage.removeItem('web_brand_details');

	    localStorage.removeItem('m_r_s_dt');
	    localStorage.removeItem('m_r_e_coupon_dt');
	    localStorage.removeItem('m_r_e_s_dt');
	    localStorage.removeItem('mob_mycart');
	    localStorage.removeItem('m_r_enq_seller_page');
	    localStorage.removeItem('m_r_p_dt');
	    localStorage.removeItem('m_r_e_p_dt');
	    localStorage.removeItem('ofr_page');
	    localStorage.removeItem('pro_ofr_dtls');

	    localStorage.removeItem('share_earn');
	    localStorage.removeItem('my_orders');
	    localStorage.removeItem('m_r_p_deals');
	    localStorage.removeItem('mob_quickcart');
	    localStorage.removeItem('partner_deals');
		
		browserHistory.push('/web/login');
	  }
	  else
	  {
	  	this.getUserDetails();
	  }
	}
	getUserDetails()
	{
		if(localStorage.user_id)
		{
			var user_id=localStorage.getItem('user_id');
		}
		else
		{
			user_id=0;
		}
		if(localStorage.source)
		{
			var source=localStorage.getItem('source');
		}
		else
		{
			source='';
		}
		if(localStorage.campaign)
		{
			var campaign=localStorage.getItem('campaign');
		}
		else
		{
			campaign='';
		}
		if(localStorage.url_id)
		{
			var url_id=localStorage.getItem('url_id');
		}
		else
		{
			url_id='';
		}
		var data1={from: 'desktop_web',uid: user_id,token:localStorage.getItem('token'),device_id: localStorage.getItem('push_device_id'), source:source,campaign:campaign,url_id:url_id}
	    var data2=JSON.stringify(data1);
	    var baseUrl='https://aquadeals.in/admin/web3/user/';
	    $.ajax({
	        method: 'POST',
	        url: baseUrl+'myprofile',
	        dataType: 'json',
	        data:{req: data2},
	        success: function(data)
	        {
	          this.setState({
	          		user_mob_num: data.details[0].mobile,
	          		user_name:data.details[0].name,
	          });
	        }.bind(this),
	        error: function(err)
	        {
	        }
	    });
	}
	getCompName(event)
	{
		event.preventDefault();
		this.setState({
			comp_name: this.refs.comp_ref_name.value
		});
	}
	render(){
	document.title="Register as Partner with AquaDeals";
  // var redirect = '/web/customer_care_seller';

  const {handleSubmit,fields:{name,number,email,company_name,comment}} = this.props;
  return (
<div className="lgt_gry web_deals web_enquire_page web_req_ptr_page">
	<WebHeaderInner />
<div className="clr">&nbsp;</div>
<div className="clr">&nbsp;</div>
<div className="clr">&nbsp;</div>
<section className="container">
	<div className="row">
	<div className="col-md-12 del_rgt">
		<div className="del_rgt_blk">
			<div className="col-md-12">
			{/* 	<Breadcrumb>
	                <Breadcrumb.Item href="/home">Home</Breadcrumb.Item>
	                <Breadcrumb.Item href={"/feedslist/"+this.state.dtype}>Feed Deals</Breadcrumb.Item>
	                <Breadcrumb.Item active>Enquire Now</Breadcrumb.Item>
	            </Breadcrumb>
	         */}
			</div>
		<div className="clr"></div>
		<div className="customer_care">
	<div className="col-md-6 col-md-offset-3">
<div className="clr">&nbsp;</div><div className="clr">&nbsp;</div>	
<div className="thumbnail">
	<div className="enquire_form">
		<div className="parnter_logo_img">
			<img src={'https://aquadeals.in/admin/assets/icons/web_icons/partner_support.png'} alt=" " />
		</div>
		<div style={{paddingTop:'8px'}}>
			<h5>Personal Details</h5>
		</div>
		<form className="mtrl_elmnts2 req_ptr_form" onSubmit={this.state.stype===0 || this.state.rtype===0 ? this.validateData : handleSubmit(this.handleFormSubmit.bind(this))} style={{marginTop:'15px'}}>
				<div className="group">      
					<img src={'https://aquadeals.in/admin/assets/icons/web_icons/cell_dl_blue.png'} alt="" className="req_ptr_lft_icon" />
					<input {...number} value={this.state.user_mob_num} placeholder="Mobile Number" type="text" maxLength={10} required />	
					<span className="highlight"></span>
					<span className="bar"></span>
					{/* <span>{number.touched && number.error && <div className="req_ptr_err">{number.error}</div>}</span> */}
				</div>
				<div className="group">      
					<img src={'https://aquadeals.in/admin/assets/icons/web_icons/user_blue.png'} alt="" className="req_ptr_lft_icon"/>
					<input {...name} value={this.state.user_name} placeholder="Name" type="text" required />
					<span className="highlight"></span>
					<span className="bar"></span>
					{/*<span>{name.touched && name.error && <div className="req_ptr_err">{name.error}</div>}</span> */}
				</div>
				<div className="group">
					<img src={'https://aquadeals.in/admin/assets/icons/web_icons/building_blue.png'} alt="" className="req_ptr_lft_icon" />
					<input {...company_name} placeholder="Company/Firm Name" type="text" required value={this.state.comp_name} onChange={this.getCompName} ref="comp_ref_name"  />
					<span className="highlight"></span>
					<span className="bar"></span>
					<span style={{color:'red',fontSize:'11px'}}>{company_name.touched && company_name.error && <div className="text-danger">{company_name.error}</div>}</span>
				</div>
				<div className="group">      
					<img src={'https://aquadeals.in/admin/assets/icons/web_icons/email_dl_blue.png'} alt="" className="req_ptr_lft_icon" />
					<input {...email} required placeholder="Email" type="text" ref="email_ref_fld" value={this.state.email_fld} onChange={this.getEmail}  />
					<span className="highlight"></span>
					<span className="bar"></span>
					<span><div className="req_ptr_err">{email.error ? email.error : ''}</div></span>
				</div>
				<div className="new_role_blk">
					<h5>My Role</h5>
					<FormGroup>
					      <Radio name="radioGroup" className={this.state.rtype === 1 ? 'role_active' : 'role_inactive'} required inline onChange={()=>{this.getRole(1)}}>
					        Hatchery owner
					      </Radio>
					      <Radio name="radioGroup" className={this.state.rtype === 2 ? 'role_active' : 'role_inactive'} required inline onChange={()=>{this.getRole(2)}}>
					        Manufacturer/Importer
					      </Radio>
					      <Radio name="radioGroup" className={this.state.rtype === 3 ? 'role_active' : 'role_inactive'} required inline onChange={()=>{this.getRole(3)}}>
					        Dealer
					      </Radio>
					</FormGroup>
				</div>
				<div className="new_role_blk">
					<h5>Categories</h5>
					<FormGroup>
					      <Radio name="radioGroup1" className={this.state.stype === 1 ? 'role_active' : 'role_inactive'} required inline onChange={()=>{this.getCat(1)}}>
					        Seed/Nauplii
					      </Radio>
					      
					      <Radio name="radioGroup1" className={this.state.stype === 2 ? 'role_active' : 'role_inactive'} required inline onChange={()=>{this.getCat(2)}}>
					        Feed/Health care
					      </Radio>
					      <Radio name="radioGroup1" className={this.state.stype === 3 ? 'role_active' : 'role_inactive'} required inline onChange={()=>{this.getCat(3)}}>
					        Aerators/Machinery
					      </Radio>
					</FormGroup>
				</div>
				<div className="">
		         	<h5 style={{paddingTop:'12px',paddingBottom:'10px'}} >Message <span>{comment.touched && comment.error && <span className="text-msg_danger">* {comment.error}</span>}</span></h5>
		         	<textarea {...comment} required placeholder={"I am interested to sell my products in Aqua deals partnership program,. I would like to know some more details. Looking forward for your reply."} rows={5} style={{width:'100%',fontSize:'13px'}} value={this.state.textarea_msg} onChange={this.txtAreaChange} ref="txtAreaMsg"></textarea>
		        </div>
        		<div style={{textAlign:'center',background:'#fff',margin:'10px 0 5px 0'}}>
					<button action="submit" className="partner_req_sub_btn">REQUEST CALL BACK</button>
				</div>
				<div className="parner_bot_img">
					<img src={'https://aquadeals.in/admin/assets/icons/web_icons/ad_partner_logo.png'} alt=""  />
				</div>
			</form>
			</div>
		</div>
		</div>
	</div>
	</div>
	</div>
	</div>
	</section>	

<Modal backdrop="static" className="showModal modal fade" show={this.state.showModal} style={{zIndex: '1111'}} onHide={this.close}>
        <Modal.Header style={{borderBottom: 'none' }}>
                <Modal.Title style={{fontSize: '16px',color:'#333'}}></Modal.Title>
              </Modal.Header>
              <Modal.Body>
              	<h4 style={{textAlign: 'center', fontSize:'14px', color:'#666'}}>{this.state.message}</h4>
              </Modal.Body>
              <Modal.Footer className="modal_footer" style={{borderTop: 'none',textAlign: 'center'}}>
                  {/* <Button style={{background: '#fff none repeat scroll 0 0',color:'#ff742a'}} onClick={ this.closeModal}>Close</Button>*/}
                  <Link to={"/web/customer_care_seller"}><Button style={{background: '#ff742a none repeat scroll 0 0',color: '#fff'}}>OK</Button></Link>
              </Modal.Footer>
      </Modal>
<WebFooter />
	
</div>
    );
  }
}


function validate(formProps){
const errors = {};
const namePattern = /^[a-zA-Z0-9\x20]{3,25}/;

// if(!formProps.name){
//   errors.name = "Enter your name";
// }
// else if(formProps.name && !namePattern.test(formProps.name)){
// 		errors.name = 'Enter minimum 3 characters';
// }

/* if(!formProps.company_name){
	errors.company_name="Please enter your company Name";
}
*/
 
if(formProps.company_name && !namePattern.test(formProps.company_name))
{
		errors.company_name = 'Enter minimum 3 characters';
}
if(formProps.comment && !namePattern.test(formProps.comment))
{
	errors.comment = 'Enter minimum 3 characters';
}




// const invalidChars = /[^0-9]/gi;
 // if(formProps.number && invalidChars.test(formProps.number)){
 // 	errors.number="invalid mobile number";
 // }

// const number_check = /^[0-9]{10}$/;  
 // if(formProps.number && !number_check.test(formProps.number)){
 // 	errors.number="Mobile number must contains 10 numbers only";
 // }

 // if(!formProps.number){
 // 	errors.number="Enter Mobile Number";
 // }


 const emailPattern = /(.+)@(.+){2,}\.(.+){2,}/;
  if (formProps.email && !emailPattern.test(formProps.email)) 
  {
    errors.email = 'Enter a valid email';
  }
 // if(!formProps.email)
 // {
 //   errors.email = "Enter your email";
 // }




// const emailPattern = /(.+)@(.+){2,}\.(.+){2,}/;
//   if (!emailPattern.test(formProps.email)) {
//     errors.email = 'Enter a valid email';
//   }
  
return errors;
}


function mapStateToProps(state){
    return {
        leads:state.posts.leads,
    }
}

export default reduxForm({
  form :'Enquiry',
  fields:['name','number','email','company_name','comment'],
  validate:validate

},mapStateToProps,actions)(Web_EnquireNow_Partner);


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Common/Web_EnquireNow_Partner.js
 **/